import { useEffect, useState } from "react";
import { Dropdown } from "@/atoms-react/dropdown/index.react";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const OtherAssetsPeriod = ({
  setResponseotherAssetsPeriodState,
  otherAssetsPeriodResponse
}: {
  setResponseotherAssetsPeriodState: (otherAssetsPeriod: string) => void;
  otherAssetsPeriodResponse?: string;
}) => {
  const [oAP, setOAP] = useState<string | undefined>(otherAssetsPeriodResponse as string);
  const { getLanguage } = usei18n();

  const otherAssetesPeriod = [
    {
      key: "1",
      value: "Ponctuelles",
      valueEn: "Non-recurring"
    },
    {
      key: "2",
      value: "Régulières",
      valueEn: "Recurring"
    }
  ];
  useEffect(() => {
    const initKey = otherAssetesPeriod.find(
      (cs) => cs.value === otherAssetsPeriodResponse || cs.valueEn === otherAssetsPeriodResponse
    );
    setOAP(initKey?.key);
  }, [otherAssetsPeriodResponse]);

  return (
    <div className="my-4 mt-4 w-full">
      <Dropdown
        onChange={(item) => {
          if (item.value !== otherAssetsPeriodResponse) {
            if (typeof item.value === "string") setOAP(item!.value);
            setResponseotherAssetsPeriodState(
              otherAssetesPeriod.find((oap) => oap.key === item.key)?.valueEn as string
            );
          }
        }}
        required={true}
        className="w-full"
        search={true}
        value={oAP}
        items={otherAssetesPeriod.map((oap) => {
          return {
            key: oap.key,
            value: getLanguage() === "fr" ? oap.value : oap.valueEn
          };
        })}
      />
    </div>
  );
};
